<template>
  <div class="app-main-layout">
    <header class="header ma-4 mt-6 mb-6 pa-0 pt-sm-2 pl-sm-4 pb-sm-5 mb-sm-15">
      <div class="d-flex align-center">
        <v-img
          alt="Modulbank"
          class="shrink mr-2"
          contain
          src="@/assets/img/logo.svg"
          transition="scale-transition"
          width="156"
        />
      </div>
    </header>
    <v-main>
      <router-view />
    </v-main>
  </div>
</template>
<script>
export default {
  created() {
    this.$store.dispatch("reset");
  },
};
</script>


